<template>
	<div :class="$style['surface-box']" @click="$emit('click')">
		<slot />
	</div>
</template>
<script>
export default {
	name: 'SufaceBox'
}
</script>

<style lang="scss" module>



	.surface-box {
		position: relative;
		// background-color: getColor(surface);
		background-color: getColor(surface);
		padding: $gutter * 3;
		border-radius: 5px;
		box-shadow: 0 1px 3px 0 getColor(shadow-light);
		overflow: visible;

		@include media-breakpoint-only(xs) {
			padding: $gutter * 2;
		}
	}
</style>
